import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import SkipLink from './SkipLink';

export default function Layout() {
    return (
        <div className="min-h-screen bg-secondary-800">
            <SkipLink />
            <Navbar />
            <main id="main-content" tabIndex={-1}>
                <Outlet />
            </main>
        </div>
    );
}
